import { Router, Request, Response } from "express";
import asyncHandler from "express-async-handler";

import { getList } from "./list";

const router = Router();

// list
router.get(
	"/",
	asyncHandler(async (req: Request, res: Response) => getList(req, res)),
);

export default router;
